import React, { useState } from 'react'
import useFetch from '../../Services/useFetch'

import { Button ,Row,Col,Container} from 'reactstrap';
import { endpoints } from '../../utils/Constants';
import { Input } from 'reactstrap'
import { useEffect } from 'react';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useAlert } from '../../Services/AlertContext';
import SelectSettingNoForm from '../Form/SelectSettingNoForm';
import useFetchSimple from '../../Services/useFetchSimple';


const SettingRow = ({ setting,updateSetting,saveNewSetting }) => {
    const [newName, setNewName] = useState(setting?.value); 
    const [newReferenceId, setNewReferenceId] = useState(setting.referenceId); 
    const { name, referenceId,newItem,value,id } = setting;

    return <Row>
        <Col><Input type={newName.length < 50 ? 'text' : 'textarea'} value={newName ? newName : value} onChange={(e) => setNewName(e.target.value)}/></Col>
        <Col><Input value={referenceId} onChange={(e) => setNewReferenceId(e.target.value)} /></Col>
        {!newItem && (newName !== value || newReferenceId !== referenceId) ? <Col><Button onClick={() => updateSetting({ id,name, value: newName , referenceId: newReferenceId  })}>Save Changes</Button></Col> : null}
        {newItem && newName ? <Col><Button onClick={() => saveNewSetting({ id,name, value: newName, referenceId: newReferenceId })}>Save New</Button></Col> : null}
    </Row>
}
const ManageSelections = () => {

    const [settingName, setSettingName] = useState();

    const [template, loadingTemplate, errorTemplate,refresh] = useFetch(settingName ? endpoints.getSettingsValues + settingName : null);
    
    const [saving, setSaving] = useState();

    const [items, setItems] = useState([]); 
    const fetch = useFetchSimple();
    const alert = useAlert();
     useEffect(() => { template && template.length && setItems(template) }, [template])


    const settingSelected = (item) => {
        setSettingName(item);
       
    }
    const postSubmit = (url, values) => {
        const val = values;
        const options = { method: 'POST', body: JSON.stringify(val) };
        setSaving(true);
        return fetch(url, options).then((result) => {
            var ret = result.body;
            if (ret.success) {
                const m = ret.messages;
                alert({

                    title: 'Saved Setting '+ values.value , body: <div>
                        {m && m.length ? m.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {
                        setSaving(false);
                        refresh();
                    }
                });
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>{"Error saving setting"}</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setSaving(false);
                        refresh();
                    }
                });

            }


        }, (error) => {
            const errors = error?.body?.errors;
            const messages = errors ? Object.keys(errors).map((x, i) => {
                return <p key={i}>{errors[x].map(y => y)}</p>
            }) : null
            alert({
                title: 'Error saving Setting', body: <div>
                    <h3>Unexpected Result</h3>
                    {messages ? messages : JSON.stringify(error)}
                </div>
            });

                setSaving(false);
                refresh();
        }).catch((e) => {
            alert({ title: 'Error saving setting', body: "Exception Result: " + e ? JSON.stringify(e) : 'No Error!' });
            setSaving(false);
        })
    };

    
    const updateSetting = (e) => {
        postSubmit(endpoints.updateSetting,e)

    }
    const saveNewSetting = (e) => {
        postSubmit(endpoints.addSetting, e)
    }
    
    const newItem = () => {
        setItems([...items, { name:settingName,newItem:true,referenceId:items.length,value:''}])
    }

    return <React.Fragment>
        <SelectSettingNoForm string endpoint={endpoints.getSettingsNames} onChange={settingSelected} />
        {loadingTemplate ? <LoadingAnimation /> : null}
        {errorTemplate ? <h3>Error</h3> : null}
        {!saving ? <Container>
            <h1>Warning! Here be dragons!</h1>
            <h3>If you remove some of these settings you will break functionality...</h3>
            <h3> Be very careful in removing or renaming items here....</h3>
            {items && items.length ? items.map(x => <SettingRow key={x.id} updateSetting={updateSetting} saveNewSetting={saveNewSetting} setting={x} />) : null}
            <Button onClick={() => { newItem() }}>New</Button>

        </Container>:<LoadingAnimation /> }
    </React.Fragment>

}

export default ManageSelections;